import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display", "minus", "plus"]
  static values = {
    price: Number,
    max: { type: Number, default: 10 }
  }

  connect() {
    this.syncButtons()
  }

  increment() {
    this.setQty(this.qty + 1)
  }

  decrement() {
    this.setQty(this.qty - 1)
  }

  get qty() {
    return parseInt(this.inputTarget.value || "0", 10)
  }

  setQty(value) {
    const next = Math.max(0, Math.min(this.maxValue, value))
    this.inputTarget.value = String(next)
    this.displayTarget.textContent = String(next)
    this.syncButtons()
    this.dispatch("change")
  }

  syncButtons() {
    if (this.hasMinusTarget) this.minusTarget.disabled = this.qty <= 0
    if (this.hasPlusTarget) this.plusTarget.disabled = this.qty >= this.maxValue
  }
}
